<template>
  <div
    class="flex w-full items-center min-[900px]:grid min-[900px]:grid-cols-[repeat(5,20vw)] min-[900px]:grid-rows-[20vw_20vw] min-[900px]:items-stretch"
  >
    <div
      class="col-span-3 row-span-1 flex flex-col p-7 font-avuText text-[4.6vw]/[5.35vw] text-avu-black min-[900px]:bg-avu-pink"
    >
      <div class="relative h-[5.35vw] overflow-hidden">
        <div
          class="absolute w-full transition-transform ease-in-out"
          :style="{
            transform: `translateY(${translateY}px)`,
            transitionDuration: isReversing ? '500ms' : '500ms',
          }"
        >
          <div
            v-for="(item, index) in dynamicValue.claims"
            :key="index"
            class="block h-[5.35vw] items-center"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <span>{{ dynamicValue.subtitle }}</span>
    </div>

    <div class="col-start-5 row-span-1 bg-avu-pink max-[900px]:hidden" />
    <div
      class="col-span-2 col-start-4 row-start-2 bg-avu-blue max-[900px]:hidden"
    />
  </div>
</template>

<script setup>
  const props = defineProps({
    dynamicValue: Object,
  });

  const dynamicValue = computed(() => props.dynamicValue || {});

  const currentClaimIndex = ref(0);
  const isReversing = ref(false);
  const translateY = ref(0);
  const normalSpeed = 1500;
  const reverseSpeed = 500;
  let interval;
  let itemHeight = 0;

  const updateItemHeight = () => {
    itemHeight =
      document.querySelector(".block")?.clientHeight ||
      window.innerWidth * 0.0535; // 5.35vw у px
  };

  const animateText = () => {
    interval = setInterval(() => {
      if (isReversing.value) {
        translateY.value = 0;

        setTimeout(() => {
          isReversing.value = false;
          currentClaimIndex.value = 0;
          animateText();
        }, reverseSpeed);

        clearInterval(interval);
      } else {
        currentClaimIndex.value++;
        translateY.value = -currentClaimIndex.value * itemHeight;

        if (currentClaimIndex.value === props.dynamicValue?.claims.length - 1) {
          clearInterval(interval);
          setTimeout(() => {
            isReversing.value = true;
            animateText();
          }, 100);
        }
      }
    }, normalSpeed);
  };

  onMounted(() => {
    updateItemHeight();
    animateText();

    window.addEventListener("resize", updateItemHeight);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateItemHeight);
  });
</script>
